import "./lib/sentry" // Sentry init — MUST be first import
import React from "react"
import ReactDOM from "react-dom/client"
import App from "./app.tsx"
import { SentryErrorBoundary } from "./components/SentryErrorBoundary"

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <SentryErrorBoundary>
      <App />
    </SentryErrorBoundary>
  </React.StrictMode>
)
